module.exports = __webpack_public_path__ + "static/media/ee.cb347ee4.svg";